import React from "react";
import { formatISTDateTime } from "../../lib/admin-time";
export default function DateDisplay({ date }) {
  return <>{formatISTDateTime(date)}</>;
}
